import { render } from "./PicCharts.vue?vue&type=template&id=3a5eae68"
import script from "./PicCharts.vue?vue&type=script&lang=js"
export * from "./PicCharts.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omninext/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__